// src/pushManager.ts
import { authStore } from '../src/services';
import storage from '../src/utils/storage';

const PUBLIC_VAPID_KEY = 'BDxJ-ltAqGJLK89joXT39vJLaoRR7wmJbB6dYGMF4vjXzqOF_Oje9O-c4WlFqJhUQh58fzT2eVj1BkVjx3GUYDo';

const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const registerPushSubscription = async (): Promise<void> => {
  if (!('serviceWorker' in navigator)) return;

  const userID = storage.get("userID");
  if (!userID) return;

  try {
    const registration = await navigator.serviceWorker.ready;

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
    });

    await authStore(subscription);
  } catch (error) {
    console.warn('Push notification registration skipped:', error);
  }
};
